import React, { FunctionComponent, useMemo } from 'react';
import Translate from 'ui/atoms/translate';
import DataRecordTable, { CellTypeEnum } from 'src/libraries/data-record-table';
import { Document, DocumentsApi, DocumentsListOrderingEnum, DocumentsValuesRetrieveFieldEnum } from 'api';
import { DataRecordOrdering } from 'ui/types/data-ordering';
import { PaginationProps } from 'ui/molecules/pagination';
import Link from 'src/ui/atoms/link';
import useApiCall from 'src/hooks/use-api-call';

export interface DashboardDocumentsTableProps {
  ordering?: DataRecordOrdering;
  onOrderBy?: (fieldName: string) => void;
  documents?: Document[];
  loading?: boolean;
  paginationProps?: PaginationProps;
  investmentId?: string;
}

const DashboardDocumentsTable: FunctionComponent<DashboardDocumentsTableProps> = (props) => {
  const { ordering, onOrderBy, documents, loading, paginationProps, investmentId } = props;

  const { makeAuthenticatedApi } = useApiCall();
  const documentsApi: DocumentsApi = useMemo(() => makeAuthenticatedApi(DocumentsApi), [makeAuthenticatedApi]);

  return (
    <DataRecordTable
      ordering={ordering}
      onOrderBy={onOrderBy}
      data={documents}
      loading={loading}
      paginationProps={paginationProps}
      cells={[
        {
          title: <Translate name={`documentTable.document`} />,
          render: ({ name }) => name,
          orderingFieldName: DocumentsListOrderingEnum.NAME_ASC,
          type: CellTypeEnum.text,
          filterName: 'name',
          searchFieldName: DocumentsValuesRetrieveFieldEnum.NAME,
          getFilterData: (params: any) =>
            documentsApi.documentsValuesRetrieve({
              ...params,
              ...(investmentId && { investmentId: investmentId }),
            }),
        },
        {
          title: <Translate name={`documentTable.actions`} />,
          alignContent: 'right',
          render: ({ file }) => (
            <Link href={file} target="_blank" icon="download" download={true} iconColor="primary" iconSize="large" />
          ),
        },
      ]}
    />
  );
};

export default DashboardDocumentsTable;
